'use client';

import { useState } from 'react';

import type { DialogRootProps } from '@chakra-ui/react';

interface IUseDialogReturnProps {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  onOpenChange: DialogRootProps['onOpenChange'];
}

export function useDialog(): IUseDialogReturnProps {
  const [isOpen, setIsOpen] = useState(false);

  const onClose = () => {
    setIsOpen(false);
  };

  const onOpen = () => {
    setIsOpen(true);
  };

  const onOpenChange: DialogRootProps['onOpenChange'] = (details) => {
    setIsOpen(details.open);
  };

  return {
    isOpen,
    onOpen,
    onClose,
    onOpenChange,
  };
}
